{
    "CMCD": "Children's Medical Center Dallas",
    "LGY": "Children's Medical Center Plano",
    "CSRAH": "CHRISTUS Santa Rosa Alamo Heights",
    "CSRCSH": "CHRISTUS Santa Rosa Children's Hospital",
    "CSRC": "CHRISTUS Santa Rosa Creekside",
    "CSREA": "CHRISTUS Santa Rosa ER ALON",
    "CSRMC": "CHRISTUS Santa Rosa Medical Center",
    "CSRNB": "CHRISTUS Santa Rosa New Braunfels",
    "CSRWHH": "CHRISTUS Santa Rosa Westover Hills Hospital",
    "CSHA": "CHRISTUS Spohn Hospital Alice",
    "CSHB": "CHRISTUS Spohn Hospital Beeville",
    "CSHK": "CHRISTUS Spohn Hospital Kleberg",
    "CSHM": "CHRISTUS Spohn Hospital Memorial",
    "CSHS": "CHRISTUS Spohn Hospital Shoreline",
    "CSHSOUTH": "CHRISTUS Spohn Hospital South",
    "CLMBSCH": "Columbus Community Hospital",
    "CMMC": "Connally Memorial Medical Center",
    "COOKCHD": "Cook Children's Medical Center",
    "DRISCOLL": "Driscoll Children's Hospital",
    "FRH": "Frio Regional Hospital",
    "GUADALU": "Guadalupe Regional Medical Center",
    "HMC": "Hendrick Medical Center",
    "HCMH": "Hill Country Memorial Hosp",
    "HRMC": "Hunt Regional Medical Center",
    "MCCC": "Methodist Campus for Continuing Care",
    "MCMC": "Methodist Charlton Medical Center",
    "MDMC": "Methodist Dallas Medical Center",
    "MH": "Methodist Hospital",
    "MHS": "Methodist Hospital South",
    "MMMC": "Methodist Mansfield Medical Center",
    "MLMC": "Methodist Midlothian Medical Center",
    "MRMC": "Methodist Richardson Medical Center",
    "MSMC": "Methodist Southlake Medical Center",
    "MSATH": "Methodist Specialty and Transplant Hospital",
    "MSOH": "Methodist Stone Oak Hospital",
    "MTH": "Methodist Texsan Hospital",
    "MMETHH": "Metropolitan Methodist Hospital",
    "MCHD": "Mitchell County Hospital District",
    "NMH": "Northeast Methodist Hospital",
    "PARKVIEW": "Parkview Hospital",
    "PRMC": "Peterson Regional Medical Center",
    "RPMH": "Rolling Plains Memorial Hosp",
    "SGH": "Southwest General Hospital",
    "THRY0": "Texas Health Allen",
    "THRJ0": "Texas Health Alliance",
    "THRX0": "Texas Health Arlington Memorial",
    "THRI0": "Texas Health Azle",
    "THB": "Texas Health Burleson",
    "THRTHCDS": "Texas Health Center for Diagnostics and Surgery",
    "THCF": "Texas Health Clearfork",
    "THRV0": "Texas Health Cleburne",
    "THRD0": "Texas Health Dallas",
    "THRT0": "Texas Health Denton",
    "THRFLO": "Texas Health Flower Mound",
    "THRA0": "Texas Health Fort Worth",
    "THRTHF": "Texas Health Frisco",
    "THRZ0": "Texas Health Heart and Vascular",
    "THRC0": "Texas Health HEB",
    "THRK0": "Texas Health Kaufman",
    "THRP0": "Texas Health Plano",
    "THPS": "Texas Health Prosper",
    "THRROC": "Texas Health Rockwall",
    "THRSOU": "Texas Health Southlake",
    "THRN0": "Texas Health Specialty Hospital",
    "THRF0": "Texas Health Stephenville",
    "THWP": "Texas Health Willow Park",
    "TSRHC": "Texas Scottish Rite Hospital",
    "TRHS": "Trinity Regional Hospital Sachse",
    "UMCHSHASA": "University Health System",
    "HASAUMCLBK": "University Medical Center Lubbock",
    "UMH": "Uvalde Memorial Hospital",
    "VVRMC": "Val Verde Regional Medical Center",
    "THAMBH": "Texas Health Arlington Memorial BH",
    "THDBH": "Texas Health Behavioral Health Dallas",
    "THSPBH": "Texas Health Springwood HEB BH",
    "THSY": "Texas Health Seay Behavioral Health Plano",
    "CCUCPRO": "Cook Children's Urgent Care Prosper",
    "CCUCA": "Cook Children's Urgent Care Alliance",
    "CCUCFTW": "Cook Children's Urgent Care Ft. Worth",
    "CCUCHUR": "Cook Children's Urgent Care Hurst",
    "CCUCMAN": "Cook Children's Urgent Care Mansfield",
    "CCUCSLK": "Cook Children's Urgent Care Southlake",
    "CCUCWR": "Cook Children's Urgent Care Walsh Ranch"
}
